export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) {
    try {
      const parsed = JSON.parse(err.message);
      if (parsed && typeof parsed === "object" && "error" in parsed) {
        return parsed.error as string;
      }
    } catch {
      // Not JSON, fall through to raw message
    }
    return err.message;
  }
  return String(err ?? "Unknown error");
}

export function isAbortError(err: unknown): boolean {
  return err instanceof DOMException && err.name === "AbortError";
}


